import { SVGProps } from "react";

export default function ArrowRightLongIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 15, width = 26, stroke = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M24.9766 8.07039C25.3672 7.67986 25.3672 7.0467 24.9766 6.65617L18.6127 0.292213C18.2222 -0.0983109 17.589 -0.0983109 17.1985 0.292213C16.8079 0.682738 16.8079 1.3159 17.1985 1.70643L22.8553 7.36328L17.1985 13.0201C16.8079 13.4107 16.8079 14.0438 17.1985 14.4343C17.589 14.8249 18.2222 14.8249 18.6127 14.4343L24.9766 8.07039ZM0 7.36328V8.36328H24.2695V7.36328V6.36328H0V7.36328Z"
        fill={stroke}
      />
    </svg>
  );
}
